"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.NAMESPACES = exports.ModelSortPredicateCreator = exports.ModelPredicateCreator = exports.Predicates = exports.AsyncItem = exports.AsyncCollection = exports.initSchema = exports.DataStoreClass = exports.DataStore = void 0;
const tslib_1 = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const util_1 = require("./util");
var datastore_1 = require("./datastore/datastore");
Object.defineProperty(exports, "DataStore", { enumerable: true, get: function () { return datastore_1.DataStore; } });
Object.defineProperty(exports, "DataStoreClass", { enumerable: true, get: function () { return datastore_1.DataStoreClass; } });
Object.defineProperty(exports, "initSchema", { enumerable: true, get: function () { return datastore_1.initSchema; } });
// eslint-disable-next-line import/export
Object.defineProperty(exports, "AsyncCollection", { enumerable: true, get: function () { return datastore_1.AsyncCollection; } });
Object.defineProperty(exports, "AsyncItem", { enumerable: true, get: function () { return datastore_1.AsyncItem; } });
var predicates_1 = require("./predicates");
Object.defineProperty(exports, "Predicates", { enumerable: true, get: function () { return predicates_1.Predicates; } });
Object.defineProperty(exports, "ModelPredicateCreator", { enumerable: true, get: function () { return predicates_1.ModelPredicateCreator; } });
Object.defineProperty(exports, "ModelSortPredicateCreator", { enumerable: true, get: function () { return predicates_1.ModelSortPredicateCreator; } });
var util_2 = require("./util");
Object.defineProperty(exports, "NAMESPACES", { enumerable: true, get: function () { return util_2.NAMESPACES; } });
exports.utils = {
    USER: util_1.USER,
    traverseModel: util_1.traverseModel,
    validatePredicate: util_1.validatePredicate,
    isNonModelConstructor: util_1.isNonModelConstructor,
    isModelConstructor: util_1.isModelConstructor,
};
// eslint-disable-next-line import/export
tslib_1.__exportStar(require("./types"), exports);
